
export default {
    props: {
        title: {
            type: String,
            default: `Buy Now`
        },
        productInfo: Array,
        activePromo: Object,
        loggedIn: {
            type: Boolean,
            default: false
        },
        showTooltip: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            plus: false
        }
    },
    async created() {
        this.plus = await this.$configs.plusNetwork();
    }
}
